import { LicencedIntervenor } from "@/Common/Api/MedfarDictionaries/Dto/Responses/LicencedIntervenor";
import { PatientRefIntervenorWithDetails } from "@/Common/Api/Patient/Dto/PatientRefIntervenorWithDetails";
import { FeatureFlagControl } from "@/Common/Components/FeatureFlagControl";
import { TextboxControl } from "@/Common/Components/Inputs/TextboxControl";
import { DoctorSearchAutocomplete } from "@/Common/Components/Search/DoctorSearchAutocomplete";
import { Guid } from "@/Common/Models/Guid";
import { TitleAndSpecialtyModel } from "@/Common/Models/MedfarDictionaries/TitleAndSpecialtyModel";
import { PatientRefIntervenorWithDetailsModel } from "@/Common/Models/Patient/PatientRefIntervenorWithDetailsModel";
import { Person } from "@/Common/Models/Person/Person";
import { SearchableItemModelT } from "@/Common/Models/SearchableItem";
import { KeyValuePair } from "@/Common/Models/UI/KeyValuePair";
import * as LocalPatientOperations from "@/Common/Operations/operations.patient.local";
import { LocalEvent } from "@/Common/Stores/Actions/LocalEvent";
import { AddOrEditConsultantPopup } from "./CliniciansComponents/AddOrEditConsultantPopup";
import { Constants } from "./CliniciansComponents/Constants";
import { IPatientProfileCliniciansProps } from "./CliniciansView";
import { ProtectPatientFileSection } from "./ProtectPatientFileSection";

import img_icon_addfavorite from "@/Globals/_images/icons/AddFavorite.png";
import img_icon_favorite from "@/Globals/_images/icons/Favorite.png";

class CliniciansEdit extends React.Component<IPatientProfileCliniciansProps, any> {
    private pageContentMargin: React.CSSProperties = { marginLeft: "45px" };
    private redx: React.CSSProperties = { color: "red", fontWeight: "bold" };
    private td: React.CSSProperties = { width: "60px", paddingRight: "15px" };
    private tdLarge: React.CSSProperties = { marginRight: "15px", width: "300px" };
    private tdContent: React.CSSProperties = { width: "80%" };

    private tdPaddingMD: React.CSSProperties = { paddingRight: "15px", width: "300px" };
    private tdPaddingRightText: React.CSSProperties = { paddingRight: "15px", textAlign: "right", width: "270px" };

    private employees: Immutable.List<SearchableItemModelT<Person>> = Immutable.List([]);

    constructor(props: IPatientProfileCliniciansProps) {
        super(props);
        this.employees = Immutable.List(cacheStore.Clinicians.map(x => {
            var licence = "";
            if (!IsNullOrWhiteSpace(x.EmployeeModel.FirstLicenceNumber))
                licence = " (" + x.EmployeeModel.FirstLicenceNumber + ")";

            return new SearchableItemModelT<Person>(x.NameWithPrefix + licence, x.ContactId, x);
        }));
    }

    public render(): JSX.Element {
        const internalIntervenors = this.props.Model.get("IntervenorsOnFile").filter(x => x.IsFromClinic() == true);
        const externalIntervenors = this.props.Model.get("IntervenorsOnFile").filter(x => x.IsFromClinic() != true);

        const specialtyCategoriesInternal = this.GroupByCategory(internalIntervenors);
        const specialtyCategoriesExternal = this.GroupByCategory(externalIntervenors);

        return (
            <div>
                {this.props.Model.get("IsAddPopupOpen") && (
                    <AddOrEditConsultantPopup
                        patientClinicianModel={this.props.Model}
                        intervenor={this.props.Model.get("PendingAddIntervenor")}
                        patientContactId={this.props.Model.get("PatientContactId")}
                        employees={this.employees}
                        redx={this.redx}
                        onEditConsultant={intervenor => this.onEditConsultant(intervenor)}
                        onAddConsultant={(intervenor, isAddPlus) => this.onAddConsultant(intervenor, isAddPlus)}
                        onClose={() => this.closeAddOrEditExternalConsultantPopup()}
                    />
                )}
                <div className="scrollable patientProfileView patient-prof">
                    <div className="block separated">
                        <div className="heading">
                            <div className="flex-container" style={{ justifyContent: "space-between" }}>
                                <div><h3 className="thin-font">{cacheStore.GetString("TreatingStaffLabel")}</h3></div>
                                <div style={{ paddingTop: "10px", paddingRight: "20px" }} onClick={this.onAddIntervenorOpen.bind(this, true)} data-cy="clinicians-add-internalProvider"><a>{"[+] " + cacheStore.GetString("AddStaffMembersInternalLabel")}</a></div>
                            </div>
                        </div>

                        <div style={this.pageContentMargin}>
                            {specialtyCategoriesInternal != null &&
                                specialtyCategoriesInternal.map((Category, idx) => {
                                    var CategoryName = Category.Key;

                                    return (
                                        <div key={"_cat_Clinic_Edit" + idx}>
                                            <div style={{ marginTop: "15px", marginBottom: "5px", fontSize: "20px" }}><strong>{CategoryName}</strong></div>
                                            <div style={{ marginLeft: "20px" }}>
                                                <table>

                                                    {Category.Value != null &&
                                                        Category.Value.map((c, idx) => this.renderMyleIntervenor(c, idx))
                                                    }
                                                </table>
                                            </div>
                                        </div>
                                    );
                                })
                            }
                        </div>

                        {specialtyCategoriesExternal != null && (
                            <div className="block separated">
                                <div className="heading">
                                    <div className="flex-container" style={{ justifyContent: "space-between" }}>
                                        <div><h3 className="thin-font">{cacheStore.GetString("ExternalConsultantLabel")}</h3></div>
                                        <div style={{ paddingTop: "10px", paddingRight: "20px" }} onClick={this.onAddIntervenorOpen.bind(this, false)} data-cy="clinicians-add-externalProvider"><a>{"[+] " + cacheStore.GetString("AddStaffMembersExternalLabel")}</a></div>
                                    </div>
                                </div>

                                <div style={this.pageContentMargin}>
                                    {specialtyCategoriesExternal.map((Category, idx) => {
                                        var CategoryName = Category.Key;

                                        return (
                                            <div key={"_cat_Clinic_Edit" + idx}>
                                                <div style={{ marginTop: "15px", marginBottom: "5px", fontSize: "20px" }}><strong>{CategoryName}</strong></div>
                                                <div style={{ marginLeft: "20px" }}>
                                                    <table>

                                                        {Category.Value != null &&
                                                            Category.Value.map((c, idx) => this.renderExternalIntervenor(c, idx))
                                                        }
                                                    </table>
                                                </div>
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>
                        )}

                        {cacheStore.ClinicSettings.EnablePatientChartAllowlist && this.renderProtectMedicalFileSection()}

                    </div>
                </div>
            </div>
        );
    }

    private renderProtectMedicalFileSection(): JSX.Element {
        return (
            <ProtectPatientFileSection
                editable
                model={this.props.Model.get("PatientFileAllowlist")}
                onMembersChange={(membersToAdd, membersToDelete) => this.onProtectPatientFileChange(membersToAdd, membersToDelete)}
            />
        );
    }

    public renderMyleIntervenor(c: PatientRefIntervenorWithDetailsModel, idx: number): JSX.Element {
        const starIconStyle: React.CSSProperties = {
            position: "absolute",
            marginTop: "9px",
            marginLeft: "-25px",
            height: "15px"
        };

        return (
            <tbody style={{ borderBottom: "15px solid white" }} key={"clinician_" + idx}>
                <tr>
                    <td style={this.tdPaddingRightText}>
                        {c.IsEditMode == true && (
                            <div className="flex-container" style={this.tdContent}>
                                {c.Model.Intervenor.IsPrimary == true && (
                                    <img
                                        onClick={this.onIsPrimaryChange.bind(this, c.Model.Intervenor.Id)}
                                        style={starIconStyle}
                                        id="_FavOn"
                                        src={img_icon_favorite}
                                    />
                                )}
                                {(c.Model.Intervenor.IsPrimary == false || c.Model.Intervenor.IsPrimary == null) && (
                                    <img
                                        onClick={this.onIsPrimaryChange.bind(this, c.Model.Intervenor.Id)}
                                        style={starIconStyle}
                                        id="_favOff"
                                        src={img_icon_addfavorite}
                                    />
                                )}
                                <TextboxControl
                                    listWidth="475px"
                                    debounceMs={200}
                                    limit={100}
                                    value={c.GetSpecialityForSearch()}
                                    className="form-control"
                                    RemoveStyle={true}
                                    autoCompleteItems={cacheStore.TitlesAndSpecialtiesCache}
                                    onClickRestrictedSearch={true}
                                    onAutoCompleteSelectCallBack={(code: string, model: TitleAndSpecialtyModel) => {
                                        this.onSpecialitySelect(c.Model.Intervenor.Id, model);
                                    }}
                                    placeholder=""
                                    id={"txtSpeciality_ClinicianEdit" + idx}
                                    valid={c.Model.LicenceOrganisationRule != null}
                                    style={{ width: "275px" }}
                                />
                            </div>
                        )}
                        {c.IsEditMode != true && (
                            <div>
                                {c.Model.Intervenor.IsPrimary == true &&
                                    <img onClick={this.onIsPrimaryChange.bind(this, c.Model.Intervenor.Id)} style={{ "marginTop": "-4px", "height": "15px" }} id="_FavOn" src={img_icon_favorite} />
                                }
                                {(c.Model.Intervenor.IsPrimary == false || c.Model.Intervenor.IsPrimary == null) &&
                                    <img onClick={this.onIsPrimaryChange.bind(this, c.Model.Intervenor.Id)} style={{ "marginTop": "-4px", "height": "15px" }} id="_favOff" src={img_icon_addfavorite} />
                                }
                                <span> {c.GetLicenceOrganisatioRuleName()}</span>
                            </div>
                        )}
                    </td>
                    <td style={this.tdLarge}>
                        {c.IsEditMode == true && (
                            <div style={this.tdContent}>
                                <TextboxControl
                                    debounceMs={200}
                                    value={c.GetNameSearch()}
                                    autoCompleteItems={this.employees}
                                    onAutoCompleteSelectCallBack={(code: string, value: Person) => {
                                        this.onDoctorEmployeeSelect(c.Model.Intervenor.Id, value);
                                    }}
                                    onAutoCompleteSelectClearTextBox={true}
                                    style={{ marginRight: "10px" }}
                                    placeholder=""
                                    id={"txtEmployees_" + idx}
                                />
                            </div>
                        )}
                        {c.IsEditMode != true && (
                            <div>
                                <strong>
                                    <span> {c.GetName()}</span>
                                </strong>
                                <span> {c.GetLicence(true)}</span>
                            </div>
                        )}
                    </td>

                    <td style={this.td}>
                        <div><span> {c.GetOrganizationAcronym()}</span></div>
                    </td>

                    <td style={this.td}>
                        {c.IsEditMode != true &&
                            <div style={this.tdContent}><a onClick={this.setEditMode.bind(this, c.Model.Intervenor.Id, true)}> {cacheStore.GetString("EDITLabel")}</a></div>
                        }
                        {c.IsEditMode == true && c.IsValid() &&
                            <div style={this.tdContent}><a onClick={this.setEditMode.bind(this, c.Model.Intervenor.Id, false)}> {cacheStore.GetString("ViewLabel")}</a></div>
                        }
                    </td>

                    <td style={this.td}>
                        <div style={this.tdContent}><a onClick={this.onDeleteIntervenor.bind(this, c.Model.Intervenor.Id)} style={this.redx}> X</a></div>
                    </td>

                </tr>
                {(c.IsEditMode == true || !IsNullOrWhiteSpace(c.Model.Intervenor.Note)) && (
                    <tr>
                        <td style={this.tdPaddingRightText}>
                            <div />
                        </td>
                        <td style={this.tdLarge}>
                            {c.IsEditMode != true && (
                                <div style={this.tdContent}>
                                    <span> {c.Model.Intervenor.Note}</span>
                                </div>
                            )}
                            {c.IsEditMode == true && (
                                <div style={this.tdContent}>
                                    <TextboxControl
                                        debounceMs={200}
                                        value={c.Model.Intervenor.Note}
                                        onChange={(value: string) => {
                                            this.onNoteChange(c.Model.Intervenor.Id, value);
                                        }}
                                        style={{ marginRight: "10px" }}
                                        placeholder={cacheStore.GetString("NotesLabel")}
                                        id={"txtEmployeesNote_" + idx}
                                    />
                                </div>
                            )}
                        </td>
                    </tr>
                )}
            </tbody>
        );
    }

    public renderExternalIntervenor(c: PatientRefIntervenorWithDetailsModel, idx: number): JSX.Element {
        return (
            <>
                {c.IsEditMode && (
                    <FeatureFlagControl
                        flag={cacheStore.ClinicSettings.EnableContactDirectory}
                        activeFeature={(
                            <AddOrEditConsultantPopup
                                patientClinicianModel={this.props.Model}
                                intervenor={this.props.Model.get("PendingAddIntervenor")}
                                patientContactId={this.props.Model.get("PatientContactId")}
                                employees={this.employees}
                                redx={this.redx}
                                onEditConsultant={intervenor => this.onEditConsultant(intervenor)}
                                onAddConsultant={(intervenor, isAddPlus) => this.onAddConsultant(intervenor, isAddPlus)}
                                onClose={() => this.setEditMode(c.Model.Intervenor.Id, false)}
                                isEditMode
                            />
                        )}
                        fallbackFeature={(
                            <tbody style={{ borderBottom: "25px solid white" }} key={"clinician_ex_" + idx}>
                                <tr>
                                    <td style={this.tdPaddingRightText}>
                                        <div style={this.tdContent}>
                                            <TextboxControl
                                                debounceMs={200}
                                                value={c.GetSpecialityForSearch()}
                                                className="form-control"
                                                RemoveStyle={true}
                                                autoCompleteItems={cacheStore.TitlesAndSpecialtiesCache}
                                                onClickRestrictedSearch={true}
                                                onAutoCompleteSelectCallBack={(code: string, model: TitleAndSpecialtyModel) => {
                                                    this.onSpecialitySelect(c.Model.Intervenor.Id, model);
                                                }}
                                                placeholder=""
                                                id={"txtSpeciality_ClinicianEdit" + idx}
                                                valid={c.Model.LicenceOrganisationRule != null}
                                            />
                                        </div>
                                    </td>
                                    <td style={this.tdLarge}>
                                        <div style={this.tdContent}>
                                            <DoctorSearchAutocomplete
                                                componentId={"txtdoctor_ClinicianEdit" + idx}
                                                onItemSelectCallback={this.onDoctorSelect.bind(this, c.Model.Intervenor.Id)}
                                                text={c.GetNameSearch()}
                                                isValid={c.Model.LicencedIntervenor != null}
                                            />
                                        </div>
                                    </td>
                                    <td style={this.td}>
                                        <div><span> {c.GetOrganizationAcronym()}</span></div>
                                    </td>
                                    <td style={this.td}>
                                        <div style={this.tdContent}><a onClick={this.setEditMode.bind(this, c.Model.Intervenor.Id, false)}> {cacheStore.GetString("ViewLabel")}</a></div>
                                    </td>
                                    <td style={this.td}>
                                        <div style={this.tdContent}><a onClick={this.onDeleteIntervenor.bind(this, c.Model.Intervenor.Id)} style={this.redx}> X</a></div>
                                    </td>
                                </tr>
                                <tr>
                                    <td style={this.tdPaddingRightText}>
                                        <div>
                                            <span> Note:</span>
                                        </div>
                                    </td>
                                    <td style={this.tdLarge}>
                                        <div style={this.tdContent}>
                                            <TextboxControl
                                                debounceMs={200}
                                                value={c.Model.Intervenor.Note}
                                                onChange={(value: string) => {
                                                    this.onNoteChange(c.Model.Intervenor.Id, value);
                                                }}
                                                style={{ marginRight: "10px" }}
                                                placeholder=""
                                                id={"txtEmployeesNote_" + idx}
                                            />
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        )}
                    />
                )}
                {(cacheStore.ClinicSettings.EnableContactDirectory || !c.IsEditMode) && (
                    <tbody style={{ borderBottom: "25px solid white" }} key={"clinician_ex_" + idx}>
                        <tr>
                            <td style={this.tdPaddingRightText}>
                                <div><span> {c.getSpecialtyName()}</span></div>
                            </td>
                            <td style={this.tdLarge}>
                                <div>
                                    <strong>
                                        <span> {c.GetName()}</span>
                                    </strong>
                                    <span> {c.GetLicence(true)}</span>
                                </div>
                            </td>
                            <td style={this.td}>
                                <div><span> {c.GetOrganizationAcronym()}</span></div>
                            </td>
                            <td style={this.td}>
                                <div style={this.tdContent}>
                                    <a
                                        onClick={() => {
                                            this.setEditMode(c.Model.Intervenor.Id, true);
                                            this.onEditExternalProvider(Constants.pendingAddIntervenorKey, c.Model);
                                        }}
                                    > {cacheStore.GetString("EDITLabel")}
                                    </a>
                                </div>
                            </td>
                            <td style={this.td}>
                                <div style={this.tdContent}><a onClick={this.onDeleteIntervenor.bind(this, c.Model.Intervenor.Id)} style={this.redx}> X</a></div>
                            </td>
                        </tr>
                        {!IsNullOrWhiteSpace(c.GetFax()) && (
                            <tr key={"clinician_ex_Info1_" + idx}>
                                <td style={this.tdPaddingRightText}><div><span> {cacheStore.GetString("FaxLabel") + ":"}</span></div></td>
                                <td style={this.tdPaddingMD}>
                                    <div>
                                        <span> {c.GetFax()}</span>
                                    </div>
                                </td>
                            </tr>
                        )}
                        {!IsNullOrWhiteSpace(c.GetPhone()) && (
                            <tr key={"clinician_ex_Info2_" + idx}>
                                <td style={this.tdPaddingRightText}><div><span> {cacheStore.GetString("PhoneLabel") + ":"}</span></div></td>
                                <td style={this.tdPaddingMD}>
                                    <div>
                                        <span> {c.GetPhone()}</span>
                                    </div>
                                </td>
                            </tr>
                        )}
                        {!IsNullOrWhiteSpace(c.GetAddress()) && (
                            <tr key={"clinician_ex_Info3_" + idx}>
                                <td style={this.tdPaddingRightText}><div><span> {cacheStore.GetString("AddressLabel") + ":"}</span></div></td>
                                <td style={this.tdPaddingMD}>
                                    <div>
                                        <span> {c.GetAddress()}</span>
                                    </div>
                                </td>
                            </tr>
                        )}
                        {!IsNullOrWhiteSpace(c.Model.Intervenor.Note) && (
                            <tr>
                                <td style={this.tdPaddingRightText}>
                                    <div>
                                        <span> Note:</span>
                                    </div>
                                </td>
                                <td style={this.tdLarge}>
                                    <div style={this.tdContent}>
                                        <span> {c.Model.Intervenor.Note}</span>
                                    </div>
                                </td>
                            </tr>
                        )}
                    </tbody>
                )}
            </>
        );
    }

    public componentDidMount(): void {
        $(window).trigger("resize");
    }

    public GroupByCategory(intervenors: Immutable.Iterable<number, PatientRefIntervenorWithDetailsModel>): KeyValuePair<string, PatientRefIntervenorWithDetailsModel[]>[] {
        return intervenors
            .groupBy(x => x.GetSpecialisationCategoryName())
            .map((x, categoryName) => {
                var items = x
                    .toArray()
                    .sortByProperty(employee => employee.GetName())
                    .sortByProperty(employee => TitleAndSpecialtyModel.getLicenceOrganisationRulePosition(employee.getTitleAndSpecialtyModel())); // MD before Resident
                return new KeyValuePair(categoryName, items);
            })
            .toArray()
            .sortByProperty(x => {
                if (x.Value[0].Model.LicenceOrganisationSpecialisation != null && x.Value[0].Model.LicenceOrganisationSpecialisation.SpecialisationCode == "0") // MD Famille
                    return -1;
                else if (x.Value.some(y => y.IsFromClinic() == true))
                    return 0;
                else
                    return x.Value[0].GetSpecialisationCategory().Position;
            });
    }

    private onDeleteIntervenor(IntervenorId: string): void {
        var operation = new LocalEvent(LocalPatientOperations.Profile.Clinicians_DeleteIntervenor);
        operation.AddItem("Id", IntervenorId);
        LocalEventDispatcher.dispatch(operation);
    }

    private onIsPrimaryChange(IntervenorId: string): void {
        var operation = new LocalEvent(LocalPatientOperations.Profile.Clinicians_IsPrimaryChange);
        operation.AddItem("Id", IntervenorId);
        LocalEventDispatcher.dispatch(operation);
    }

    private onNoteChange(IntervenorId: string, NoteValue: string): void {
        var operation = new LocalEvent(LocalPatientOperations.Profile.Clinicians_OnNoteChange);
        operation.AddItem("Id", IntervenorId);
        operation.AddItem("Note", NoteValue);
        LocalEventDispatcher.dispatch(operation);
    }

    private onAddIntervenorOpen(IsInternal: boolean): void {
        var operation = new LocalEvent(LocalPatientOperations.Profile.Clinicians_AddIntervenorOpen);
        operation.AddItem("IsInternal", IsInternal);
        LocalEventDispatcher.dispatch(operation);
    }

    private onDoctorSelect(IntervenorId: string, item: LicencedIntervenor): void {
        var operation = new LocalEvent(LocalPatientOperations.Profile.Clinicians_SelectDoctor);
        operation.AddItem("value", item);
        operation.AddItem("Id", IntervenorId);
        LocalEventDispatcher.dispatch(operation);
    }

    private onDoctorEmployeeSelect(IntervenorId: string, item: Person): void {
        var operation = new LocalEvent(LocalPatientOperations.Profile.Clinicians_SelectDoctorEmployee);
        operation.AddItem("value", item);
        operation.AddItem("Id", IntervenorId);
        LocalEventDispatcher.dispatch(operation);
    }

    private onEditConsultant(intervenor: PatientRefIntervenorWithDetailsModel): void {
        sessionStore.dispatch(LocalPatientOperations.Profile.Clinicians_EditConsultant, { intervenor });
    }

    private onAddConsultant(intervenor: PatientRefIntervenorWithDetailsModel, isAddedExtraProvider: boolean = false): void {
        sessionStore.dispatch(LocalPatientOperations.Profile.Clinicians_AddIntervenorSave, { intervenor, IsAddPlus: isAddedExtraProvider });

        if (!isAddedExtraProvider)
            this.closeAddOrEditExternalConsultantPopup();
    }

    private onSpecialitySelect(IntervenorId: string, item: TitleAndSpecialtyModel): void {
        var operation = new LocalEvent(LocalPatientOperations.Profile.Clinicians_SelectSpeciality);
        operation.AddItem("value", item);
        operation.AddItem("Id", IntervenorId);
        LocalEventDispatcher.dispatch(operation);
    }

    private setEditMode(intervenorId: string, setEditModel: boolean): void {
        sessionStore.dispatch(
            LocalPatientOperations.Profile.Clinicians_SetIntervenorEditMode,
            { intervenorId, setEditModel }
        );
    }

    private onEditExternalProvider(intervenorId: string, model: PatientRefIntervenorWithDetails): void {
        sessionStore.dispatch(LocalPatientOperations.Profile.Clinicians_ContactDirectory_ExternalProvider_Edit, { intervenorId, model });
    }

    private closeAddOrEditExternalConsultantPopup(): void {
        sessionStore.dispatch(LocalPatientOperations.Profile.Clinicians_AddIntervenorClose);
    }

    private onProtectPatientFileChange(membersToAdd: Guid[] | null, membersToDelete: Guid[] | null): void {
        sessionStore.dispatch(
            LocalPatientOperations.Profile.Clinicians_EditPatientFileAllowlist,
            { membersToAdd, membersToDelete }
        );
    }
}

export { CliniciansEdit };
